/**
 *
 * Large
 *
 * Large checkbox variation from GDS, created by combining the RadioButton and
 * LargeLabel components.
 *
 */
import withLabelWrapper from '../../../../hoc/withLabelWrapper';
import LargeLabel from '../../../variations/label/LargeLabel';
import BaseRadioButton from '../Base';

var Large = function Large(props) {
  return withLabelWrapper(LargeLabel, {
    classes: "radio--large ".concat(props.extraClasses || ''),
    type: 'radio'
  })(BaseRadioButton)(props);
};

Large.displayName = 'Large';
export default Large;